import React from 'react';
import {
  Typography,
  Container,
  Box,
  Grid,
  Chip,
  Avatar,
  Button,
} from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import Header from '../components/Header';
import Footer from '../components/Footer';

function About() {
  const skills = [
    'Product Strategy',
    'Agile/Scrum',
    'AI-first product',
    'Roadmap Planning',
    'OKRs & KPIs',
    'User Research',
    'Data Analytics',
    'Go-to-Market',
    'Team Leadership',
    'Stakeholder Management',
    'Product Discovery',
  ];

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: '#fafafa' }}>
      <Header />

      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0F172A 0%, #111827 50%, #1E293B 100%)',
          position: 'relative',
          overflow: 'hidden',
          py: { xs: 10, md: 14 },
          '&::before': {
            content: '""',
            position: 'absolute',
            top: '-50%',
            right: '-20%',
            width: '600px',
            height: '600px',
            background: 'radial-gradient(circle, rgba(126, 181, 216, 0.07) 0%, transparent 70%)',
            borderRadius: '50%',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: '-30%',
            left: '-10%',
            width: '400px',
            height: '400px',
            background: 'radial-gradient(circle, rgba(255,255,255,0.02) 0%, transparent 70%)',
            borderRadius: '50%',
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={4} sx={{ textAlign: { xs: 'center', md: 'left' } }}>
              <Avatar
                src="/Profile.jpeg"
                alt="Kevin Chen"
                sx={{
                  width: { xs: 180, md: 220 },
                  height: { xs: 180, md: 220 },
                  mx: { xs: 'auto', md: 0 },
                  border: '4px solid rgba(255,255,255,0.2)',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
                }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography
                variant="overline"
                sx={{
                  color: '#7EB5D8',
                  fontWeight: 700,
                  letterSpacing: 3,
                  fontSize: '0.85rem',
                  mb: 2,
                  display: 'block',
                }}
              >
                Founder & Managing Director
              </Typography>
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 800,
                  color: 'white',
                  fontSize: { xs: '2.5rem', md: '3.5rem' },
                  mb: 3,
                  lineHeight: 1.2,
                }}
              >
                Kevin Chen
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontWeight: 400,
                  lineHeight: 1.7,
                  mb: 5,
                  maxWidth: 550,
                  fontSize: { xs: '1rem', sm: '1.15rem' },
                }}
              >
                Product leader with 10+ years of experience transforming complex challenges
                into elegant solutions. Passionate about building products that matter and
                teams that thrive. <br /> Part-time amateur writer.
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <Button
                  variant="contained"
                  startIcon={<LinkedInIcon />}
                  href="https://www.linkedin.com/in/kevin-c-10812648/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    background: 'linear-gradient(90deg, #1E3A5F 0%, #2C5282 100%)',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: { xs: '1rem', sm: '1.1rem' },
                    px: { xs: 4, sm: 6 },
                    py: { xs: 1.5, sm: 2 },
                    borderRadius: '50px',
                    textTransform: 'none',
                    boxShadow: '0 8px 30px rgba(30, 58, 95, 0.45)',
                    border: '1px solid rgba(126, 181, 216, 0.25)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      background: 'linear-gradient(90deg, #2C5282 0%, #1E3A5F 100%)',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 12px 40px rgba(30, 58, 95, 0.55)',
                    },
                  }}
                >
                  Connect on LinkedIn
                </Button>
                <Button
                  variant="outlined"
                  startIcon={<AutoStoriesIcon />}
                  href="https://mybook.to/2OKUkC"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    borderColor: 'rgba(255,255,255,0.5)',
                    color: 'white',
                    fontWeight: 700,
                    fontSize: { xs: '1rem', sm: '1.1rem' },
                    px: { xs: 4, sm: 6 },
                    py: { xs: 1.5, sm: 2 },
                    borderRadius: '50px',
                    textTransform: 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      borderColor: 'white',
                      bgcolor: 'rgba(255,255,255,0.1)',
                      transform: 'translateY(-3px)',
                    },
                  }}
                >
                  Read My Novella
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* About Actuation Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 8, md: 12 } }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography
              variant="overline"
              sx={{
                color: '#7EB5D8',
                fontWeight: 700,
                letterSpacing: 3,
                fontSize: '0.85rem',
                mb: 2,
                display: 'block',
              }}
            >
              About Actuation
            </Typography>
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 800,
                mb: 3,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                lineHeight: 1.2,
              }}
            >
              Turning Product Vision Into
              <Box
                component="span"
                sx={{
                  display: 'block',
                  color: '#7EB5D8',
                }}
              >
                Market Reality
              </Box>
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'text.secondary',
                fontWeight: 400,
                lineHeight: 1.7,
                fontSize: { xs: '1rem', sm: '1.15rem' },
                mb: 2,
              }}
            >
              Actuation is a product management consulting practice founded on the belief
              that great products don't happen by accident—they're the result of clear
              strategy, relentless focus, and deep customer understanding.
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'text.secondary',
                fontWeight: 400,
                lineHeight: 1.7,
                fontSize: { xs: '1rem', sm: '1.15rem' },
              }}
            >
              We partner with startups and enterprises to define product vision, build
              high-performing teams, and execute roadmaps that drive measurable business
              outcomes. Whether you're launching your first product or scaling an existing
              portfolio, we bring the expertise to accelerate your success.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                bgcolor: 'white',
                borderRadius: 3,
                p: 4,
                boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                border: '1px solid',
                borderColor: 'divider',
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}
              >
                <RocketLaunchIcon sx={{ color: '#4A7FC1' }} />
                Core Expertise
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {skills.map((skill, index) => (
                  <Chip
                    key={index}
                    label={skill}
                    sx={{
                      bgcolor: index % 2 === 0 ? 'rgba(74, 127, 193, 0.1)' : 'rgba(30, 41, 59, 0.07)',
                      color: index % 2 === 0 ? '#2C5282' : '#334155',
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      py: 2,
                      '&:hover': {
                        bgcolor: index % 2 === 0 ? 'rgba(74, 127, 193, 0.18)' : 'rgba(30, 41, 59, 0.13)',
                      },
                    }}
                  />
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Footer />
    </Box>
  );
}

export default About;
